const overMap = document.querySelector(`[data-item="over-map"]`)
const showMap = document.querySelector(`[data-item="show-map"]`)

if (overMap) {
    if (showMap) {
        showMap.addEventListener('click', (e) => {
            e.preventDefault()

            overMap.classList.toggle('hide')

        })
    }
}